import {CircularProgress, Stack, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const Loading = ({
  message,
  progressSize = 50,
  subheaderTypographyProps = {},
  suffix = '',
  titleTypographyProps = {},
  ...props
}) => {
  return (
    <Stack
      data-testid="loading-message"
      {...props}
      sx={[
        {
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          margin: 'auto',
          textAlign: 'center',
          height: '100%',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <CircularProgress
        color="primary"
        size={progressSize}
        sx={{marginBottom: 2}}
      />
      <Typography
        variant="h5"
        gutterBottom
        {...titleTypographyProps}
        sx={[
          {
            color: 'text.secondary',
          },
          ...(Array.isArray(titleTypographyProps.sx)
            ? titleTypographyProps.sx
            : [titleTypographyProps.sx]),
        ]}
      >
        {message ? message : `Loading ${suffix}`}
      </Typography>
      <Typography
        variant="h6"
        {...subheaderTypographyProps}
        sx={[
          {
            color: 'text.secondary',
          },
          ...(Array.isArray(subheaderTypographyProps.sx)
            ? subheaderTypographyProps.sx
            : [subheaderTypographyProps.sx]),
        ]}
      >
        One moment please
      </Typography>
    </Stack>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
  progressSize: PropTypes.number,
  suffix: PropTypes.string,
  titleTypographyProps: PropTypes.object,
  subheaderTypographyProps: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default Loading;
